import { createContext, useContext, type ReactNode } from 'react';
import type { Tone } from './tone';

export interface ToastOptions {
  title: ReactNode;
  description?: ReactNode;
  tone?: Tone;
  /** ms before auto-dismiss; `null` = stay until dismissed. Errors default to null. */
  duration?: number | null;
  action?: { label: string; onClick: () => void };
}

export interface ToastApi {
  show: (t: ToastOptions) => string;
  dismiss: (id: string) => void;
  success: (title: ReactNode, description?: ReactNode) => string;
  error: (title: ReactNode, description?: ReactNode) => string;
  info: (title: ReactNode, description?: ReactNode) => string;
  warning: (title: ReactNode, description?: ReactNode) => string;
}

export const ToastContext = createContext<ToastApi | null>(null);

/** Imperative toasts: `const toast = useToast(); toast.success('Issue updated')`. */
export function useToast(): ToastApi {
  const api = useContext(ToastContext);
  if (!api) throw new Error('useToast must be used inside <ToastProvider>');
  return api;
}
